import { DataTable } from "@msuite/ui/table";
import { WarehouseLocationsMenu } from "@/components/stock";
import { useWarehouseLocations } from "@/hooks/use-warehouse-locations";
import { articleWarehouseLocationColumns } from "@/sites/data/warehouse-locations/table-config";
import type { ArticlePanelBaseProps } from "../shared";

/**
 * Where the article stands, and how much of it stands there.
 *
 * The general panel carries the warehouse-wide balance, which says nothing about which shelf to
 * walk to. This is the same total broken out per location, beside each shelf's own load.
 */
export function ArticleWarehouseLocations({ articleId }: ArticlePanelBaseProps) {
	/** Query */
	const { warehouseLocations, isLoading, refetch, queryKey } = useWarehouseLocations({ articleId });

	/** Render */
	return (
		<DataTable
			data={warehouseLocations}
			columns={articleWarehouseLocationColumns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<WarehouseLocationsMenu query={{ articleId }} />}
			persistenceKey="article-warehouse-locations-table"
		/>
	);
}
